import { render, staticRenderFns } from "./AskAnswer.vue?vue&type=template&id=abc1a5aa&scoped=true&"
import script from "./AskAnswer.vue?vue&type=script&lang=js&"
export * from "./AskAnswer.vue?vue&type=script&lang=js&"
import style0 from "./AskAnswer.vue?vue&type=style&index=0&id=abc1a5aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc1a5aa",
  null
  
)

export default component.exports